/**
 * A document is eligible for a new review request while it has no status
 * yet, or is sitting in Draft/Rejected — the "not currently under or past
 * review" states. Shared by the row menu and the Details panel so they
 * can't drift on when Request/View Review show.
 */
function canRequestReview(status: string | null | undefined): boolean {
  return !status || status === "draft" || status === "rejected"
}

function canViewReview(status: string | null | undefined): boolean {
  return !!status && status !== "draft"
}

export { canRequestReview, canViewReview }
